import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { hideToast } from "../../store/slices/formconfig";
import "./style.css";

const Toaster: React.FC = () => {
  const dispatch = useDispatch();
  const { toastMessage, toastVisible, toastType } = useSelector(
    (state: any) => state.formConfig
  );

  useEffect(() => {
    if (toastVisible) {
      const timer = setTimeout(() => {
        dispatch(hideToast());
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [toastVisible, dispatch]);

  if (!toastVisible || !toastMessage) return null;

  return (
    <div className={`toaster toaster-${toastType}`}>
      <span className="toaster-message">{toastMessage}</span>
      <button className="toaster-close" onClick={() => dispatch(hideToast())}>
        &times;
      </button>
    </div>
  );
};

export default Toaster;
